export default __webpack_public_path__ + "7b90ad2.svg";